import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { SettingsService } from '../../../core/http/settings.service';

@Component({
  selector: 'app-cartegory-modal',
  templateUrl: './cartegory-modal.component.html',
  styleUrls: ['./cartegory-modal.component.scss']
})
export class CartegoryModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  cartegories = null;
  mode = null;


  constructor(private modal: ModalService, public auth: SettingsService) { }

  ngOnInit(): void {

    this.auth
      .getCategories()
      .subscribe(
        (resSuccess) => {

          this.cartegories = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

  addNew() {
    this.mode = "add"
  }
  edit() {
    this.mode = "edit"
  }

}
